import { FaArrowRight } from "react-icons/fa6";
import papers from "../images/papers.png";
import papers2 from "../images/5.png";
import emailjs from '@emailjs/browser';
import { useRef, useState } from "react";
import { Bounce, toast } from 'react-toastify';

const EmailComponent = (props) => {
    const form = useRef();
    const [loading, setLoading] = useState(false);
    const sendEmail = (e) => {
        e.preventDefault();
        setLoading(true);
        emailjs
            .sendForm('service_1nsk4kr', 'template_pko2ti5', form.current, {
                publicKey: 'vm0yy7EL7qssyT0RL',
            })
            .then(
                () => {
                    setLoading(false);
                    toast.success('Thanks For Contacting Us', {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                        transition: Bounce,
                    });
                },
                (error) => {
                    setLoading(false);
                    toast.error('An Error Occurred, Please try again', {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                        transition: Bounce,
                    });
                },
            );
    };
    const isBlue = props.isBlue;
    return (
        <div className={`${isBlue ? "background-with-image-blue" : "background-with-image"}`}>
            <div className='container mx-auto py-16 md:py-32 flex flex-col md:flex-row items-center justify-center relative'>
                {/* Your email subscribe form or other content here */}
                {/* Pinned notes */}
                <div className="w-lg md:w-1/3 z-10 relative cursor-default select-none">
                    <img
                        src={isBlue ? papers : papers2}
                        alt="Logo"
                        className="mb-3 md:mr-12 w-[200px] md:w-[300px] object-contain"
                    />
                </div>

                {/* Email input */}
                <form ref={form} onSubmit={sendEmail} className="w-[80%] mt-16 md:mt-0 md:w-2/3 z-10 flex items-center bg-white rounded-full shadow-lg overflow-hidden md:max-w-md md:w-full">
                    <input
                        type="email"
                        placeholder="EMAIL ADDRESS"
                        className="flex-grow px-4 py-3 text-sm italic text-gray-400 placeholder-gray-400 focus:outline-none"
                        aria-label="Email Address"
                        name="user_email"
                        required
                    />
                    <button
                        type="submit"
                        className="submit-button bg-[#80a2a5] p-[5px] mr-[5px] border-2 border-[#80a2a5] hover:bg-transparent hover:text-[#80a2a5] rounded-full transition duration-300"
                        aria-label="Submit email"
                    >
                        {loading ? (
                            <span className="loader loader-blue"></span>
                        ) : (
                            <FaArrowRight />
                        )}

                    </button>
                </form>
            </div>
        </div>
    )
};

export default EmailComponent;